import { autoserialize, inheritSerialization } from 'cerialize';

import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class Directions extends AbstractModel {
  @autoserialize
  rideRequestId: number;

  @autoserialize
  polyline: string;

  @autoserialize
  distance: number;

  @autoserialize
  duration: number;
}
